import {useLoginContext, useUserContext} from '@hconnect/login'
import {CommonHeader} from '@hconnect/uikit/src/lib2'
import {getPlantName, useUpmPlantsContext} from '@hconnect/upm'
import React, {FC} from 'react'

type EventAffiliatesHeaderProps = {
  plantId: string
}

export const EventAffiliatesHeader: FC<EventAffiliatesHeaderProps> = ({plantId}) => {
  const upmPlants = useUpmPlantsContext()
  const plantName = getPlantName(upmPlants, plantId)
  const {loggedUser} = useUserContext()
  const {logout} = useLoginContext()

  return (
    <CommonHeader
      disableAppSelect
      data-test-id="header-content"
      appName="Cockpit"
      plant={{plantId, plantName}}
      upmPlants={upmPlants}
      supportedLanguages={[]}
      locationPath={location.pathname}
      closeDropdownOnLanguageSwitch
      user={
        loggedUser
          ? {name: loggedUser.name ?? undefined, email: loggedUser.eMail ?? undefined}
          : undefined
      }
      onLogout={() => void logout()}
    />
  )
}
